import { Components } from '@mui/material';

export function getMuiTable(): Components['MuiTable'] {
  return {
    styleOverrides: {
      root: {
        borderCollapse: 'separate',
        borderSpacing: '0 20px',
      },
    },
  };
}
